import styles from './styles.module.scss';

const Accessory = ({
  state,
  accessory,
  room,
  idx,
  toggledAccessory,
  setToggledAccessory,
  isTutorialMode,
}) => {
  const toggled = accessory === toggledAccessory;

  const selected = state.selectedAccessories.some(
    (selectedAccessory) => selectedAccessory.key === accessory.key
  );

  return (
    <div className={styles.accessory}>
      <button
        style={{
          right: accessory.buttonstyle_right,
          top: accessory.buttonstyle_top,
          pointerEvents: isTutorialMode ? 'none' : 'auto',
          animationDelay: `${200 + idx * 200}ms`,
        }}
        onClick={() =>
          setToggledAccessory(accessory === toggledAccessory ? null : accessory)
        }
        className={`${toggled ? styles.toggledButton : ''} ${
          selected ? styles.selectedAccessory : ''
        }`}
      >
        {idx + 1}
      </button>
      {accessory.hotspot === 'TRUE' && (
        <picture>
          <img
            src={`${process.env.PUBLIC_URL}/images_iax/accessories/${room.key}/${accessory.key}.svg`}
            title={accessory.title}
            alt={accessory.title}
            style={{
              opacity: toggled ? '1' : '0',
              zIndex: toggled || null === toggledAccessory ? '5' : '2',
            }}
          />
        </picture>
      )}
    </div>
  );
};

export default Accessory;
